import { SET_ATUALIZAR_DADOS_CADASTRAIS } from '../actions/actionTypes';

const initialState = {
    atualizarDadosCadastrais: {
        necessarioAtualizar: false,
        url: ''
    }
};

export const dadoCadastralReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_ATUALIZAR_DADOS_CADASTRAIS:
            return {
                ...state,
                atualizarDadosCadastrais: action.newValue
            };
        default:
            return state;
    }
};
